var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 242,
    height: 52,
    viewBox: "0 0 242 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_127_233)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.197 3.95608V16.1961C101.197 22.5054 97.2355 25.7511 91.7484 25.7511C86.5048 25.7511 82.0492 22.6386 82.0492 16.1961V3.95608H86.1037V16.1961C86.1037 20.0448 88.3458 22.0917 91.7484 22.0917C95.151 22.0917 97.0851 19.8625 97.0851 16.1961V3.95608H101.197Z",
    fill: "#553124"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.68 3.89299H126.799V25.2955H124.241L112.78 10.8612V25.2674H108.661V3.92805H111.999L122.694 17.1775L122.68 3.89299Z",
    fill: "#553124"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.719 25.2955V3.92805H137.802V25.2955H133.719Z",
    fill: "#553124"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.786 25.2955V3.95608H160.481V7.83278H148.905V13.6654H159.886V17.3878H148.905V25.2955H144.786Z",
    fill: "#553124"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.54 14.7309C188.475 20.255 185.015 25.7792 177.336 25.7792C169.657 25.7792 166.111 20.3812 166.111 14.759C166.111 9.1367 169.8 3.47938 177.343 3.47938C184.886 3.47938 188.604 9.1437 188.54 14.7309ZM170.166 14.8221C170.259 18.3272 172.193 22.0917 177.329 22.0917C182.465 22.0917 184.414 18.3062 184.493 14.794C184.571 11.2819 182.494 7.15979 177.329 7.15979C172.164 7.15979 170.08 11.2258 170.173 14.8221H170.166Z",
    fill: "#553124"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.056 25.2955H209.156L202.795 18.152H198.834V25.2955H194.715V3.89299C198.175 3.89299 201.642 3.92805 205.102 3.92805C210.245 3.92805 212.981 7.31401 212.981 11.0084C212.981 13.9388 211.613 16.8971 207.465 17.7243L214.077 25.0221L214.056 25.2955ZM198.834 7.68557V14.5276H205.102C207.723 14.5276 208.841 12.8171 208.841 11.1066C208.841 9.39609 207.687 7.68557 205.102 7.68557H198.834Z",
    fill: "#553124"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.874 9.78866L230.804 19.0984H229.987L223.003 9.78866V25.3235H218.884V3.95608H223.64L230.467 13.1466L237.301 3.95608H242.007V25.3235H237.888L237.874 9.78866Z",
    fill: "#553124"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.1768 45.7235H86.3759L85.0936 48.4786H82.0492L88.7398 33.8761H91.8344L98.5321 48.4786H95.416L94.1768 45.7235ZM90.2799 36.9396L87.5363 43.1577H93.0808L90.2799 36.9396Z",
    fill: "#553124"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.137 48.4786H111.791L107.443 43.5713H104.728V48.4786H101.913V33.855H109.012C112.529 33.855 114.385 36.1685 114.385 38.6922C114.385 40.6971 113.446 42.7231 110.61 43.2839L115.13 48.2753L115.137 48.4786ZM104.728 36.4278V41.1037H109.026C109.351 41.1211 109.676 41.0736 109.981 40.9639C110.287 40.8543 110.566 40.6849 110.802 40.4661C111.038 40.2473 111.226 39.9837 111.355 39.6913C111.484 39.399 111.55 39.084 111.55 38.7658C111.55 38.4475 111.484 38.1326 111.355 37.8402C111.226 37.5479 111.038 37.2843 110.802 37.0655C110.566 36.8466 110.287 36.6772 109.981 36.5676C109.676 36.458 109.351 36.4104 109.026 36.4278H104.728Z",
    fill: "#553124"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.549 48.4786H118.382V33.8761H129.549V36.547H121.204V39.933H129.292V42.4988H121.204V45.7936H129.585L129.549 48.4786Z",
    fill: "#553124"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.127 33.855H146.942V48.4786H145.194L137.315 38.608V48.4575H134.499V33.8761H136.777L144.127 42.9334V33.855Z",
    fill: "#553124"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.236 45.7235H154.435L153.153 48.4786H150.108L156.799 33.8761H159.886L166.584 48.4786H163.468L162.236 45.7235ZM158.339 36.9396L155.588 43.1577H161.133L158.339 36.9396Z",
    fill: "#553124"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.8168 35.201C23.3884 35.201 21.003 35.1379 18.6892 35.0118V42.2184C21.003 42.3445 23.3884 42.4076 25.8168 42.4076C48.4458 42.4076 66.7984 36.7293 66.7984 29.733V22.5264C66.7984 29.5297 48.4458 35.201 25.8168 35.201Z",
    fill: "#B84031"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.2624 44.2934V51.5C55.294 49.7825 66.7984 45.0645 66.7984 39.5194V32.3198C66.7984 37.8299 55.3012 42.5759 39.2624 44.2934Z",
    fill: "#B84031"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.8165 25.4146C17.1344 25.4992 8.47422 24.5458 0.0283508 22.5755V51.5H3.98252L6.13153 31.0509C12.6432 32.1175 19.2358 32.6405 25.838 32.6142C48.467 32.6142 66.8196 26.9429 66.8196 19.9396V12.74C66.7981 19.7363 48.4455 25.4146 25.8165 25.4146Z",
    fill: "#B84031"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.5131 12.1371C43.5891 12.5647 54.9287 15.4249 57.5648 19.1124C57.9298 18.6481 58.1398 18.0852 58.1665 17.5C58.1665 13.0835 45.867 9.43815 29.9644 8.89134L30.4658 5.15486C47.1493 5.77176 60.5519 9.67649 63.7038 14.7309C64.1531 14.056 64.4011 13.2719 64.4202 12.4666C64.4202 5.88392 47.1493 0.549077 25.8741 0.549077V22.5755H28.1735L29.5131 12.1371Z",
    fill: "#B84031"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.82098 39.4353C11.0674 39.5825 12.8296 39.7858 14.7494 39.926V37.6336C13.0943 37.5137 11.4483 37.2936 9.82098 36.9746V39.4353Z",
    fill: "#B84031"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_127_233"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 242,
    height: 51,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.25f6a458ffc10bf6d24b4d6687edb58a.svg";
export { ForwardRef as ReactComponent };